export interface ICenterCoordinator {
    id: number,
    fullName: string
}